import '../../../types/product.js';
import { isContactLens } from '../../../types/typeguards.js';

const getReviewsConfigKeys = (product, activeSku)=>{
    let productId = product.masterSku;
    let variantId = activeSku;
    if (isContactLens(product)) {
        productId = product.productMasterKey;
        variantId = undefined // SKU is not required for CL
        ;
    }
    return {
        productId,
        variantId
    };
};

export { getReviewsConfigKeys };
//# sourceMappingURL=get-reviews-config-keys.js.map
